import { GridCol as FfeCol, type GridColProps } from "@sb1/ffe-grid-react";
import type { FC } from "react";

const GridCol: FC<GridColProps> = ({ children, lg = { cols: 8, offset: 2 }, md = { cols: 12, offset: 0 }, ...rest }) => {
	return (
		<FfeCol lg={lg} md={md} {...rest}>
			{children}
		</FfeCol>
	);
};

export default GridCol;
